var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorP"},[_c('div',{staticClass:"errorP-inner"},[_vm._m(0),_c('p',[_vm._v("토큰이 유효하지 않습니다.")]),_c('div',[_c('router-link',{staticClass:"btn color-1 btn-large w-200 btn-round100 mr-10",attrs:{"to":"/"}},[_vm._v("꼬랩 사이트로 이동")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('img',{attrs:{"src":require("@/assets/img/sub/notice.png"),"alt":"notice"}})])
}]

export { render, staticRenderFns }